export var DocumentNotificationRecipientType;
(function (DocumentNotificationRecipientType) {
    DocumentNotificationRecipientType[DocumentNotificationRecipientType["normal"] = 0] = "normal";
    DocumentNotificationRecipientType[DocumentNotificationRecipientType["cc"] = 1] = "cc";
    DocumentNotificationRecipientType[DocumentNotificationRecipientType["bcc"] = 2] = "bcc";
})(DocumentNotificationRecipientType || (DocumentNotificationRecipientType = {}));
